import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Error } from "../../../Data/error.dto";
import { CustomerPaymentReducer } from "../../Reducers/Dashboard/CustomerTransaction";
import { CustomerTransaction } from "../../../Data/transaction.dto";

export interface CustomerPaymentsStats {
  total_payments: number;
  payments_pending: number;
  payments_received: number;
}

export interface CustomerTransactionState {
  loading: boolean;
  transactions: CustomerTransaction[] | [];
  customer_payments: CustomerPaymentsStats | null;
  count: number;
  total_pages: number;
  current_page: number;
  page_size: number;
  error: Error;
}

const initialState: CustomerTransactionState = {
  transactions: [],
  customer_payments: null,
  count: 0,
  total_pages: 1,
  current_page: 1,
  page_size: 10,
  loading: false,
  error: {},
};

const customerTransactionSlice = createSlice({
  name: "customer_transaction",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    CustomerPaymentReducer(builder);
  },
});

export const { } = customerTransactionSlice.actions;

export default customerTransactionSlice.reducer;
